export default __webpack_public_path__ + "static/setup-pix-1d354f84db4bbf26ce34e0fb49558e9f.png";